export default {
  // ? ==========================
  // ? =====  Multilocation  ====
  // ? ==========================

  multiLocation: {},

  // ? ===================
  // ? =====  Layout  ====
  // ? ===================

  navigation: {
    '.smallNavMenu': {
      backgroundColor: 'dark!important'
    },
    a: {
      color: 'primary'
    }
  },

  footer: {
    img: {
      filter: 'none'
    },
    justifyContent: 'space-evenly',
    '.footerContainer': {
      justifyContent: 'space-evenly'
    },
    '.gonationLogo ': {
      order: '5',
      marginTop: '1rem',
      textAlign: 'center',
      svg: {
        height: '16px'
      }
    },
    '.locationSwitcher': {
      display: 'none'
    },
    '.multiButtonContainer': {
      justifyContent: 'flex-start'
    }
  },

  locationsPage: {
    '.locationTitle': {
      fontSize: ['2rem'],
      marginBottom: '2rem'
    },
    '.logo': {
      backgroundColor: ['black', 'transparent', '', ''],
      img: {
        maxHeight: ['', '', '', 250],
        height: ['', '', '', 210]
      }
    },
    '.CTAS': {
      flexWrap: 'wrap'
    },
    '.enterSiteButton': {
      variant: 'buttons.primary',
      margin: '0!important'
      //   width: '100%',
    },
    '.CTAButton': {
      width: '100%',
      margin: '.5rem 0 .5rem 0'
    },
    '.enterSiteButtonContainer': { margin: '.5rem 0 .5rem 0' },
    '.enterSiteButtonContainer, .enterSiteButton': {
      width: '100%',
      textAlign: 'center',
      justifyContent: 'center'
    }
  },

  ctaWidget: {
    display: 'none !important',
    zIndex: '999',
    color: 'light',
    '#online-order-cta svg': {
      display: ['none', '', 'block']
    }
  },

  // ? ====================
  // ? ==== Reuseables ====
  // ? ====================

  title: {},
  subtitle: {},
  text: {},

  // ? ====================
  // ? ====  Homepage  ====
  // ? ====================

  homepageHero: {
    // display: 'none!important',
    video: {
      marginTop: '200px'
    },
    '.videoContainer': {
      //   display: 'none!important'
      height: ['auto', '', '', '100vh'],
      marginTop: ['84px', '', '', '0']
    },
    // '.videoContainer': {
    //   marginTop: ['84px', '', '', 'unset'],
    //   height: ['auto', '', '', 'unset']
    // },
    // height: 'auto',
    '.title': {
      borderBottom: '2px solid',
      borderLeft: 'none',
      paddingLeft: '0rem',
      textTransform: 'uppercase',
      letterSpacing: '-3px'
    },
    '.section': {
      margin: '1rem',
      display: 'none'
    }
  },

  homepageSlider: {
    // slick styles
    padding: '0rem',
    '.slick-initialized .slick-slide > div': {
      overflow: 'hidden',
      position: 'relative',
      height: '60vh'
    },
    '.slick-slide .imageFill': {
      paddingBottom: '60vh'
    },
    '.slick-dots': {
      bottom: '10px'
    }
  },

  homepageReservation: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: ['3rem 1rem', '5rem 1rem', ' 7rem 1rem', ' 10rem 1rem'],
    flexDirection: 'column',
    '#scriptWidget': {
      width: '100%',
      '> div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    },
    '.textContent': {
      marginBottom: '2rem',
      textAlign: 'center'
    },
    '.title': {
      fontSize: ['2rem', '', '2.5rem'],
      fontWeight: '400'
    },

    '.ot-dtp-picker.wide .ot-dtp-picker-form': {
      height: '197px',
      width: '203px'
    },
    '.ot-dtp-picker.wide': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },

    '.ot-dtp-picker.wide .ot-title': {
      fontSize: ['20px', '', '30px']
    }

    // '#ot-reservation-widget': {
    //   maxWidth: '990px',
    //   margin: '0 auto',
    //   '.ot-dtp-picker': {
    //     width: ['', '', '100%'],
    //     margin: '0 auto',
    //   },
    //   '.ot-title': {
    //     fontSize: ['2rem', '', '2.5rem'],
    //     fontWeight: '300',
    //     marginBottom: '3rem',
    //     textTransform: 'uppercase',
    //   },
    //   '.ot-dtp-picker-form': {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    //   },
    //   '.ot-party-size-picker': {},

    //   '.ot-dtp-picker-selector': {
    //     width: ['', '', '25%'],
    //     borderRight: '1px solid lightgrey',
    //     borderBottom: 'none',
    //   },
    //   '.ot-dtp-picker-button': {
    //     width: ['', '', '25%'],
    //   },
    // },
  },

  homepageContentBoxes: {
    padding: '2rem 0',
    maxHeight: '100vh',
    '.contentBoxes': {
      maxHeight: '100vh',
      padding: '0rem',
      display: 'grid',
      gridTemplateColumns: '3fr 1fr 1fr',
      gridTemplateRows: '2fr 2fr',
      gap: '0px 0px',
      gridTemplateAreas: '". . ."". . ."',
      width: '100%',
      a: {
        padding: '0rem',
        height: '100%',
        width: '100%',
        maxHeight: '100vh',
        color: 'white!important',
        img: {
          height: '100%',
          width: '100%',
          objectFit: 'cover'
        }
      },
      '> a:nth-of-type(1)': {
        gridColumnStart: '1',
        gridColumnEnd: '2',
        gridRowStart: '1',
        gridRowEnd: '3'
      },
      '> a:nth-of-type(2)': {
        maxHeight: '50vh',
        gridColumnStart: '2',
        gridColumnEnd: '5',
        gridRowStart: '1',
        gridRowEnd: '2'
      },
      '> a:nth-of-type(3)': {
        maxHeight: '50vh',
        gridColumnStart: '2',
        gridColumnEnd: '5',
        gridRowStart: '2',
        gridRowEnd: '3'
      }
    }
  },

  homepageContentBoxes1: {
    // padding: '0rem',
    // padding: '2rem 1rem!important',
    maxWidth: 'unset',
    '.box': {
      height: '400px',
      padding: '0rem',
      width: ['100%', 'calc(50% - 1rem)', '33.33%'],
      margin: ['1rem 0rem', '0.5rem', '0rem'],
      position: 'relative',
      transition: 'all ease-in-out 0.8s',
      overflow: 'hidden',
      '.title': { color: 'white' },
      ':hover': {
        '.title': {
          // left: '1rem',

          left: '50%'
          // padding: '2rem',
        },
        img: {
          transform: 'scale(1.1)'
        }
      },
      img: {
        height: '100%',
        objectFit: 'cover',
        // filter: 'brightness(0.8)',
        margin: '0rem',
        transition: 'all ease-in-out 0.7s'
      }
    },

    '.title': {
      position: 'absolute',
      top: '50%',
      left: ['50%', '', '', '-50%'],
      transform: 'translate(-50%, -50%)',
      padding: '2rem 2rem',
      //   color: '#8B734D',
      backgroundColor: 'rgb(12 12 12 / 82%)',
      width: '80%',
      margin: '0px auto',
      textTransform: 'uppercase',
      fontWeight: '300',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      textAlign: 'center',
      borderColor: 'primary'
    }
  },

  homepagePrivateDiningSection: {
    padding: ['3rem 1rem', '5rem 1rem', ' 7rem 1rem', ' 10rem 1rem'],
    backgroundColor: 'background',
    backgroundImage: 'none',
    '.title': {
      fontWeight: '300',
      fontSize: ['2rem', '2.25rem', '2.75rem', '3rem'],
      textTransform: 'uppercase'
    },
    '.subtitle': {
      color: 'primary',
      // borderBottom: '1px solid lightgrey',
      marginBottom: '1rem'
    },
    '.text': {
      opacity: '0.8'
    },
    '.ctaButton': {
      variant: 'buttons.secondary',
      // borderBottom: 'solid 1px',
      order: '4'
    }
  },

  homepageContentBoxes2: {
    overflow: 'hidden',
    padding: '0rem',
    width: '100%',
    '.contentBoxes': {
      width: '100vw'
    },
    '.box': {
      width: '25vw',
      height: '25vw',
      margin: '0rem',
      padding: '0rem',
      img: {
        height: '100%',
        objectFit: 'cover'
      },
      '.title': {
        color: 'white'
      }
    }
  },

  homepageGiftcards: {
    backgroundAttachment: 'fixed',
    backgroundImage:
      "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://media.gonation.com/w_2500/sites/siena/giftcard-bg.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    color: 'white',
    padding: ['5rem 1rem', '', '10rem 1rem'],
    justifyContent: 'center',
    '.lazyload-wrapper': {
      maxWidth: '600px',

      '.image': {
        objectFit: 'contain'
      }
    },
    '.content': {
      padding: ['1rem', '2rem', '3rem', '4rem'],
      maxWidth: '600px',
      order: ['2', '', 'unset']
    },
    '.title': {
      fontSize: ['2rem', '', '2.5rem', '5rem'],
      fontWeight: '300',
      textTransform: 'uppercase'
    },
    '.text': {
      color: 'white',
      fontSize: '1.3rem',
      margin: '2rem 0rem',
      '> *': {
        color: 'white'
      }
    },
    '.ctaButton': {
      variant: 'buttons.primary',
      padding: '1.5rem 3rem'
    }
  },

  homepageQuote: {
    variant: 'customVariants.homepagePrivateDiningSection',
    '.title': {
      lineHeight: '1.5',
      fontSize: ['1.5rem', '', '2rem', '2.75rem'],
      fontWeight: '300',
      textTransform: 'uppercase',
      order: '2'
    },
    '.subtitle': {
      order: '1',
      color: 'primary'
    },
    '.section': {
      maxWidth: '1000px'
    },
    a: {
      order: '4'
    },

    '.ctaButton': {
      variant: 'buttons.secondary'
      // borderBottom: 'solid 1px',
    }
  },

  homepageHours: {
    padding: ['2rem 1rem', '4rem 1rem'],
    '.title': {
      // variant: 'customVariants.title',
      fontWeight: '300',
      fontSize: ['2rem', '2.25rem', '2.75rem', '3rem'],
      textTransform: 'uppercase',
      marginBottom: '4rem'
    },
    '.dayofWeekText': {
      color: 'primary',
      marginBottom: '1rem'
    },
    '.closed': {
      textAlign: ['right', '', '', 'center']
    },
    '.dayContainer': {
      flexWrap: ['', '', '', 'nowrap'],
      '.dayContainer': {
        flexDirection: ['column', '', '', 'row']
      }
    }
  },

  instagramLink: {
    '.ctaButton': {
      backgroundColor: 'transparent',
      fontSize: ['2rem', '2.5rem', '3rem', '4rem'],
      margin: '0rem',
      fontWeight: '300',
      textTransform: 'lowercase'
    },
    backgroundColor: '#f2f5f0'
  },

  instagramWidget: {
    backgroundColor: '#f2f5f0',
    '.logoAndTextContainer': {
      display: 'none'
    }
  },

  homepageHeroShout: {
    bottom: 40,
    display: 'none!important'
  },

  homepageShout: {
    display: 'none!important'
  },

  homepageAbout: {},

  homepageMenu: {},

  homepageGallery: {},

  homepageContactUs: {},

  // ? ========================
  // ? =====  About page  =====
  // ? ========================

  aboutSection: {
    '.text': {
      textAlign: 'left'
    }
  },

  // ? ========================
  // ? ====  Menu page  ====
  // ? ========================

  menu: {
    '.menuItemDescription': {
      color: 'dark'
    }
  },

  // ? ========================
  // ? ====  Gallery page  ====
  // ? ========================

  gallery: {
    '.albumsContainer': {
      borderTop: '2px solid',
      borderBottom: '2px solid'
    },

    '.albumContainer': {
      '.lazyload-wrapper ': {
        width: '100%'
      }
    },

    '.albumTitle': {
      backgroundColor: 'transparent',
      color: 'black',
      border: 'none',
      margin: '1.5rem',
      fontWeight: '300',
      textTransform: 'uppercase'
    }
  },

  // ? ========================
  // ? ====  Events page  ====
  // ? ========================

  events: {
    '.container': {
      padding: '0.5rem'
    },
    '.textContent': {
      display: 'none'
    },
    '.heading': {
      display: 'none'
    },
    '.eventItemContainer': {
      width: ['calc(50% - 0.5rem)', '', 'calc(50% - 2rem)'],
      margin: ['0.25rem', '', '1rem']
    },
    '.eventItemImage': {
      maxHeight: '400px'
    },
    '.eventItemTitle': {
      fontSize: ['1.25rem', '1.5rem'],
      fontWeight: '300',
      textTransform: 'uppercase'
    },

    '.eventItemBtn': {
      variant: 'buttons.secondary',
      borderRadius: '0px',
      textAlign: 'center',
      padding: ['0.75rem', '', '', '1rem']
    },

    '.modal': {
      backgroundColor: 'rgba(215,211,204)',
      color: '#6c6c6c',
      border: 'none',
      padding: '0rem',
      maxWidth: '1000px',
      width: ['90%', '', '', '100%'],
      maxHeight: '95vh',
      '.eventItemDateContainer': {
        marginRight: '0rem',
        textAlign: 'right'
      }
    },

    '.modalImage': {
      maxHeight: ['', '', '', '50vh']
    },

    '.modalContentContainer, .modalEventName, .eventMonth, .modalEventDescription': {
      color: '#6c6c6c'
    },
    '.modalContentContainer': {
      display: 'flex',
      flexWrap: 'wrap',
      padding: ['1rem', '', '2rem', '3rem'],
      maxHeight: ['', '', '', '45vh']
    },

    '.modalEventDate': {
      margin: '0 0 0 auto',
      width: '50px',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      fontSize: ['1.25rem', '', '1.5rem'],
      '.eventMonth, .eventDate': {
        fontSize: ['1.25rem', '', '1.5rem']
      }
    },

    '.modalEventTime': {
      width: '100%'
    },

    '.modalEventName': {
      fontSize: ['1.25rem', '', '1.5rem'],
      fontWeight: '400',
      textTransform: 'uppercase',
      width: 'calc(100% - 50px)',
      svg: {
        marginRight: '0.75rem'
      }
    },

    '.modalEventDescription': {
      maxHeight: ['134px', '', 'unset'],
      overflow: ['scroll', '', '', 'unset'],
      '::-webkit-scrollbar': {
        display: 'none'
      },
      MsOverflowStyle: 'none',
      scrollbarWidth: 'none'
    },

    '.eventCTABtns': {
      // padding: '1rem',

      margin: ['0rem auto', '0rem 0rem 0rem auto'],
      a: {
        variant: 'buttons.secondary',
        backgroundColor: '#353535',
        borderColor: '#353535',
        textTransform: 'uppercase',
        padding: ['0.5rem', '0.5rem 1rem', '1rem 2rem'],
        margin: '0.5rem'
      }
    }
  },

  // ? ========================
  // ? ====  Contact page  ====
  // ? ========================

  contactForm: {
    // backgroundColor: 'black',
    color: 'white',
    '.title': {
      color: 'primary'
    }
  },

  locationMap: {
    backgroundColor: 'black',
    '.title': {
      color: 'primary'
    },
    '.content_container': {
      '.text, .dayofWeekText, .timeBlocks': {
        color: 'white'
      }
    }
  },
  thimble: {
    '.title': { color: 'primary' }
  },
  thimblePage: {
    video: {
      width: '100%'
    },
    '.videoContainer': {
      width: '100%'
    },
    '.muteToggle': {
      display: 'none'
    }
  }
}
